import { createActions, createReducer } from "reduxsauce";

export const { Types, Creators } = createActions({
    listarUsuarios: ["payload"],
    listarUsuariosSucesso: ["payload"],
    listarBasesSucesso: ["payload"],
    adicionarUsuario: ["payload"],
    editarUsuario: ["payload"],
    editarUsuarioSaga: ["payload"],
    deletarUsuario: ["payload"],
    deletarUsuarioSucesso: ["payload"],
    listarBases: ["payload"],
    getMotoristas: ["payload"],
    getMotoristasSucesso: ["payload"],
    onAtualizarUsuario: ["payload"],
    onEditarUsuario: ["payload"]
});

const INIT_STATE = {
    valoresIniciais: {
        name: "",
        cpf: "",
        email: "",
        telefone: "",
        base: { label: "", value: "" },
        senha: "",
        confirmarSenha: "",
        cnpjParceiro: "",
        nomeParceiro: "",
        cnpj: "",
        veiculo: "",
        cnh: "",
        placaVeiculo: "",
        cnpj_cliente: []
    },
    usuariosLista: [],
    basesLista: [],
    usuarioEditar: {}
};

const getMotoristasSucesso = (state = INIT_STATE, action) => {
    const dataMotorista = action.payload;

    let { valoresIniciais } = state;

    if (dataMotorista.existe) {
        valoresIniciais = {
            name: dataMotorista.data.name,
            cpf: dataMotorista.data.cpf,
            email: dataMotorista.data.email,
            telefone: dataMotorista.data.telefone,
            base: {
                label: dataMotorista.data.base,
                value: dataMotorista.data.base
            },
            senha: "",
            confirmarSenha: "",
            cnpj: dataMotorista.data.cnpj_empresa,
            veiculo: dataMotorista.data.tipo_veiculo,
            cnh: dataMotorista.data.cnh,
            placaVeiculo: dataMotorista.data.placa_veiculo
        };
    }

    return {
        ...state,
        valoresIniciais
    };
};

const onAtualizarUsuario = (state = INIT_STATE, action) => {
    const payload = action.payload;
    const listaUsuarios = state.usuariosLista;

    return {
        ...state,
        usuariosLista: [...listaUsuarios, payload]
    };
};

const onEditarUsuario = (state = INIT_STATE, action) => {
    const payload = action.payload;
    let response = {};

    if (payload.grupo_usuario === "motorista") {
        let bases = Object.keys(payload.base);
        response = {
            name: payload.name_base,
            ativo: payload.ativo,
            cnpj_empresa: payload.cnpj_empresa,
            cpf: payload.cpf,
            grupo_emp: payload.grupo_emp,
            empresas: payload.empresas,
            telefone: payload.telefone_base,
            email: payload.email_base,
            base: bases,
            tableData: {
                id: payload.tableId
            },
            grupo_usuario: payload.grupo_usuario
        };
    } else {
        response = payload;
    }

    let novaLista = state.usuariosLista.map(item =>
        item.tableData.id === payload.tableId ? response : item
    );

    return {
        ...state,
        usuariosLista: novaLista
    };
};

const listarUsuariosSucesso = (state = INIT_STATE, action) => ({
    ...state,
    usuariosLista: action.payload
});

const listarBasesSucesso = (state = INIT_STATE, action) => ({
    ...state,
    basesLista: action.payload
});

const editarUsuario = (state = INIT_STATE, action) => {
    const { usuarioSelecionado } = action.payload;

    return {
        ...state,
        usuarioEditar: usuarioSelecionado
    };
};

const deletarUsuario = (state = INIT_STATE, action) => ({
    ...state,
    usuarioDeletar: action.payload
});

const deletarUsuarioSucesso = (state = INIT_STATE, action) => {
    const { usuariosLista } = state;
    const { cpf } = action.payload;

    const novaLista = usuariosLista.filter(usuario => usuario.cpf !== cpf);

    return {
        ...state,
        usuariosLista: novaLista
    };
};

export default createReducer(INIT_STATE, {
    [Types.LISTAR_USUARIOS_SUCESSO]: listarUsuariosSucesso,
    [Types.EDITAR_USUARIO]: editarUsuario,
    [Types.DELETAR_USUARIO]: deletarUsuario,
    [Types.LISTAR_BASES_SUCESSO]: listarBasesSucesso,
    [Types.DELETAR_USUARIO_SUCESSO]: deletarUsuarioSucesso,
    [Types.GET_MOTORISTAS_SUCESSO]: getMotoristasSucesso,
    [Types.ON_ATUALIZAR_USUARIO]: onAtualizarUsuario,
    [Types.ON_EDITAR_USUARIO]: onEditarUsuario
});
